/* ============================================
   WebToMania — Global Scripts
   Deferred · Non-blocking · IntersectionObserver
   ============================================ */

(function () {
  'use strict';

  /* --- Header scroll effect --- */
  var header = document.querySelector('.header');
  if (header) {
    var onScroll = function () {
      if (window.scrollY > 60) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* --- Mobile navigation --- */
  var hamburger = document.querySelector('.hamburger');
  var mobileNav = document.querySelector('.mobile-nav');
  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', function () {
      hamburger.classList.toggle('open');
      mobileNav.classList.toggle('open');
      document.body.style.overflow = mobileNav.classList.contains('open') ? 'hidden' : '';
    });
    // Close on link click
    mobileNav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        hamburger.classList.remove('open');
        mobileNav.classList.remove('open');
        document.body.style.overflow = '';
      });
    });
  }

  /* --- Scroll reveal (IntersectionObserver) --- */
  var revealEls = document.querySelectorAll('.reveal');
  if (revealEls.length && 'IntersectionObserver' in window) {
    var revealObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          revealObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

    revealEls.forEach(function (el) {
      revealObs.observe(el);
    });
  } else {
    // Fallback: show all if IO not supported
    revealEls.forEach(function (el) { el.classList.add('visible'); });
  }

  /* --- Counter animation (stats) --- */
  var counters = document.querySelectorAll('[data-count]');
  if (counters.length && 'IntersectionObserver' in window) {
    var countObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animateCount(entry.target);
          countObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });

    counters.forEach(function (el) { countObs.observe(el); });
  }

  function animateCount(el) {
    var target = parseInt(el.getAttribute('data-count'), 10);
    var suffix = el.getAttribute('data-suffix') || '';
    var prefix = el.getAttribute('data-prefix') || '';
    var duration = 1800;
    var start = 0;
    var startTime = null;

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      // Ease out cubic
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = Math.floor(eased * target);
      el.textContent = prefix + current + suffix;
      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        el.textContent = prefix + target + suffix;
      }
    }
    requestAnimationFrame(step);
  }

  /* --- Lazy load images (native + IO fallback) --- */
  /* Native loading="lazy" handles most cases.
     This adds fade-in effect when images enter viewport. */
  var lazyImgs = document.querySelectorAll('img[loading="lazy"]');
  if (lazyImgs.length && 'IntersectionObserver' in window) {
    var imgObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var img = entry.target;
          // If using data-src pattern
          if (img.dataset.src) {
            img.src = img.dataset.src;
            if (img.dataset.srcset) {
              img.srcset = img.dataset.srcset;
            }
          }
          img.style.opacity = '1';
          imgObs.unobserve(img);
        }
      });
    }, { rootMargin: '100px' });

    lazyImgs.forEach(function (img) {
      img.style.opacity = '0';
      img.style.transition = 'opacity 0.4s ease';
      imgObs.observe(img);
    });
  }

  /* --- Smooth scroll for anchor links --- */
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      var targetId = this.getAttribute('href');
      if (targetId === '#') return;
      var targetEl = document.querySelector(targetId);
      if (targetEl) {
        e.preventDefault();
        var offset = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-h'), 10) || 76;
        var top = targetEl.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    });
  });

  /* --- Service Tabs — removed (now using full-width blocks) --- */

  /* --- Portfolio Filter --- */
  var filterBtns = document.querySelectorAll('.filter-btn');
  var portfolioCards = document.querySelectorAll('.portfolio-card');

  if (filterBtns.length && portfolioCards.length) {
    filterBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var filter = this.dataset.filter;

        // Update active button
        filterBtns.forEach(function (b) {
          b.classList.remove('active');
          b.setAttribute('aria-selected', 'false');
        });
        this.classList.add('active');
        this.setAttribute('aria-selected', 'true');

        // Filter cards
        portfolioCards.forEach(function (card) {
          if (filter === 'all' || card.dataset.category === filter) {
            card.classList.remove('hidden');
            card.style.animation = 'svcFadeIn .4s ease';
          } else {
            card.classList.add('hidden');
            card.style.animation = '';
          }
        });
      });
    });
  }

  /* --- Contact Form Validation --- */
  var contactForm = document.getElementById('contactForm');
  if (contactForm) {
    contactForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var valid = true;
      var required = contactForm.querySelectorAll('[required]');
      required.forEach(function (field) {
        field.style.borderColor = '';
        if (!field.value.trim()) {
          field.style.borderColor = '#EF4444';
          valid = false;
        }
        if (field.type === 'email' && field.value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(field.value)) {
          field.style.borderColor = '#EF4444';
          valid = false;
        }
      });

      if (valid) {
        var btn = contactForm.querySelector('button[type="submit"]');
        btn.innerHTML = 'Message Sent! ✓';
        btn.style.background = '#16A34A';
        btn.disabled = true;
        // In production, replace with actual form submission (Formspree, Netlify Forms, etc.)
        // contactForm.submit();
      }
    });
  }

  /* --- Set current year in footer --- */
  var yearEl = document.getElementById('year');
  if (yearEl) yearEl.textContent = new Date().getFullYear();

  /* --- Team Slider (reuses same pattern as testimonials) --- */
  var teamTrack = document.getElementById('teamTrack');
  var teamPrev = document.getElementById('teamPrev');
  var teamNext = document.getElementById('teamNext');
  var teamDotsEl = document.getElementById('teamDots');

  if (teamTrack && teamPrev && teamNext && teamDotsEl) {
    var teamCards = teamTrack.querySelectorAll('.team-card');
    var teamIndex = 0;
    var teamAuto;

    function teamPerView() {
      if (window.innerWidth >= 1024) return 4;
      if (window.innerWidth >= 768) return 3;
      return 2;
    }

    function teamTotal() {
      return Math.max(teamCards.length - teamPerView() + 1, 1);
    }

    function buildTeamDots() {
      teamDotsEl.innerHTML = '';
      for (var i = 0; i < teamTotal(); i++) {
        var d = document.createElement('button');
        d.className = 'slider-dot' + (i === teamIndex ? ' active' : '');
        d.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        d.dataset.index = i;
        d.addEventListener('click', function () {
          teamGoTo(parseInt(this.dataset.index, 10));
          resetTeamAuto();
        });
        teamDotsEl.appendChild(d);
      }
    }

    function updateTeam() {
      var gap = 24;
      var cardW = teamCards[0].offsetWidth + gap;
      teamTrack.style.transform = 'translateX(-' + (teamIndex * cardW) + 'px)';
      teamDotsEl.querySelectorAll('.slider-dot').forEach(function (d, i) {
        d.classList.toggle('active', i === teamIndex);
      });
    }

    function teamGoTo(i) {
      var max = teamTotal() - 1;
      teamIndex = i < 0 ? max : i > max ? 0 : i;
      updateTeam();
    }

    function startTeamAuto() { teamAuto = setInterval(function () { teamGoTo(teamIndex + 1); }, 4000); }
    function resetTeamAuto() { clearInterval(teamAuto); startTeamAuto(); }

    teamNext.addEventListener('click', function () { teamGoTo(teamIndex + 1); resetTeamAuto(); });
    teamPrev.addEventListener('click', function () { teamGoTo(teamIndex - 1); resetTeamAuto(); });

    // Touch
    var tStartX = 0;
    teamTrack.addEventListener('touchstart', function (e) { tStartX = e.touches[0].clientX; }, { passive: true });
    teamTrack.addEventListener('touchend', function (e) {
      var diff = tStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) { diff > 0 ? teamGoTo(teamIndex + 1) : teamGoTo(teamIndex - 1); resetTeamAuto(); }
    }, { passive: true });

    teamTrack.addEventListener('mouseenter', function () { clearInterval(teamAuto); });
    teamTrack.addEventListener('mouseleave', function () { startTeamAuto(); });

    function initTeam() {
      if (teamIndex >= teamTotal()) teamIndex = 0;
      buildTeamDots();
      updateTeam();
    }

    initTeam();
    startTeamAuto();
    var teamResize;
    window.addEventListener('resize', function () { clearTimeout(teamResize); teamResize = setTimeout(initTeam, 200); });
  }

  /* --- Testimonial Slider --- */
  var track = document.getElementById('testimonialTrack');
  var prevBtn = document.getElementById('sliderPrev');
  var nextBtn = document.getElementById('sliderNext');
  var dotsContainer = document.getElementById('sliderDots');

  if (track && prevBtn && nextBtn && dotsContainer) {
    var cards = track.querySelectorAll('.testimonial-card');
    var currentIndex = 0;
    var autoPlayInterval;
    var slidesPerView = 1;

    function getSlidesPerView() {
      if (window.innerWidth >= 768) return 2;
      return 1;
    }

    function getTotalSlides() {
      return Math.max(cards.length - slidesPerView + 1, 1);
    }

    function buildDots() {
      dotsContainer.innerHTML = '';
      var total = getTotalSlides();
      for (var i = 0; i < total; i++) {
        var dot = document.createElement('button');
        dot.className = 'slider-dot' + (i === currentIndex ? ' active' : '');
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.dataset.index = i;
        dot.addEventListener('click', function () {
          goTo(parseInt(this.dataset.index, 10));
          resetAuto();
        });
        dotsContainer.appendChild(dot);
      }
    }

    function updateSlider() {
      var gap = 24;
      var cardWidth = cards[0].offsetWidth + gap;
      track.style.transform = 'translateX(-' + (currentIndex * cardWidth) + 'px)';
      // Update dots
      var dots = dotsContainer.querySelectorAll('.slider-dot');
      dots.forEach(function (d, i) {
        d.classList.toggle('active', i === currentIndex);
      });
    }

    function goTo(index) {
      var max = getTotalSlides() - 1;
      currentIndex = index < 0 ? max : index > max ? 0 : index;
      updateSlider();
    }

    function nextSlide() { goTo(currentIndex + 1); }
    function prevSlide() { goTo(currentIndex - 1); }

    function startAuto() {
      autoPlayInterval = setInterval(nextSlide, 5000);
    }

    function resetAuto() {
      clearInterval(autoPlayInterval);
      startAuto();
    }

    nextBtn.addEventListener('click', function () { nextSlide(); resetAuto(); });
    prevBtn.addEventListener('click', function () { prevSlide(); resetAuto(); });

    // Touch / swipe support
    var touchStartX = 0;
    track.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });
    track.addEventListener('touchend', function (e) {
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) nextSlide(); else prevSlide();
        resetAuto();
      }
    }, { passive: true });

    // Pause on hover
    track.addEventListener('mouseenter', function () { clearInterval(autoPlayInterval); });
    track.addEventListener('mouseleave', function () { startAuto(); });

    // Init & resize
    function initSlider() {
      slidesPerView = getSlidesPerView();
      if (currentIndex >= getTotalSlides()) currentIndex = 0;
      buildDots();
      updateSlider();
    }

    initSlider();
    startAuto();

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(initSlider, 200);
    });
  }

})();
